import { render, staticRenderFns } from "./AddModules.vue?vue&type=template&id=3a056c35"
import script from "./AddModules.vue?vue&type=script&lang=js"
export * from "./AddModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports